import { combineReducers } from "redux";

import { reducer as rewards } from "../modules/rewards/reducer";

export const rootReducer = combineReducers({ rewards });
